export default "__VITE_ASSET__xafnmK0y__"